import Box from '@mui/material/Box';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import CoverageIcon from '@mui/icons-material/Texture';
import Divider from '@mui/material/Divider';
import DownloadIcon from '@mui/icons-material/GetApp';
import IconButton from '@mui/material/IconButton';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemText from '@mui/material/ListItemText';
import PropTypes from 'prop-types';
import React, {Fragment} from 'react';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import geometryFromExtent from '../util/geometry-from-extent';
import setActiveQuad from '../actions/set-active-quad';
import setFootprint from '../actions/set-footprint';
import setSelectedQuad from '../actions/set-selected-quad';
import {Chip, ListItemSecondaryAction, Thumbnail} from './list';
import {addQueryParams} from '@apps-common/js-client/api/util';
import {connect} from 'react-redux';
import {trackEvent} from '../analytics';
import {useAuth} from '@apps-common/auth-react';

const QuadListItem = ({
  selected,
  setFootprint,
  setActiveQuad,
  quad,
  setSelectedQuad,
}) => {
  const auth = useAuth();

  const clearFootprint = () => {
    setFootprint(null);
  };

  const handleMouseEnter = () => {
    const geometry = geometryFromExtent(quad.bbox);
    setFootprint(geometry);
  };

  const handleMouseLeave = () => {
    clearFootprint();
  };

  const handleClick = () => {
    setSelectedQuad(quad);
  };

  const handleDetailsClick = () => {
    setSelectedQuad(null);
    setActiveQuad(quad);
    clearFootprint();
  };

  return (
    <Fragment>
      <ListItem
        selected={selected}
        ContainerProps={{'data-qe': 'quad-result'}}
        onClick={handleClick}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        button
      >
        <ListItemAvatar>
          <Box mr={2}>
            <Thumbnail src={quad._links.thumbnail} />
          </Box>
        </ListItemAvatar>
        <ListItemText disableTypography>
          <Box mb={0.5}>
            <Tooltip title="Quad ID">
              <Typography variant="body1" display="inline" noWrap>
                {quad.id}
              </Typography>
            </Tooltip>
          </Box>
          <Tooltip title="Quad Coverage">
            <Chip icon={<CoverageIcon />} label={`${quad.percent_covered}%`} />
          </Tooltip>
        </ListItemText>

        <ListItemSecondaryAction>
          {quad._links && quad._links.download && (
            <Tooltip title="Download Quad">
              <IconButton
                onClick={() => {
                  const downloadUrl = addQueryParams(quad._links.download, {
                    token: auth.user?.accessToken,
                  });
                  trackEvent('Downloaded Quad', {quadId: quad.id});
                  window.location.href = downloadUrl;
                }}
                data-qe="download-quad"
                size="large"
              >
                <DownloadIcon />
              </IconButton>
            </Tooltip>
          )}
          <Tooltip title="View Quad's Scenes">
            <IconButton
              onClick={handleDetailsClick}
              data-qe="view-quad-scenes"
              size="large"
            >
              <ChevronRightIcon />
            </IconButton>
          </Tooltip>
        </ListItemSecondaryAction>
      </ListItem>
      <Divider />
    </Fragment>
  );
};

QuadListItem.propTypes = {
  setActiveQuad: PropTypes.func.isRequired,
  setFootprint: PropTypes.func.isRequired,
  quad: PropTypes.object.isRequired,
  selected: PropTypes.bool,
  setSelectedQuad: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  setFootprint,
  setActiveQuad,
  setSelectedQuad,
};

export default connect(null, mapDispatchToProps)(QuadListItem);
